import React from 'react'
import {useHistory} from "react-router";
import {useTranslation} from "react-i18next"

import {IonButton, IonButtons, IonIcon, IonItem, IonItemOptions, IonLabel} from "@ionic/react"
import {shieldCheckmarkOutline, shieldCheckmarkSharp} from "ionicons/icons"

import {Key as ItemType}    from "../../types/Key"

import {useLockingSystems} from "../../contexts/LockingSystemContext"

import ListItemOptionDelete from "../Keys/List/ListItemOptionDelete"
import ListItemOptionBlock  from "../Keys/List/ListItemOptionBlock"
import ListItemOptionReset  from "../Keys/List/ListItemOptionReset"

import IconKeyInUse                from "../common/Icons/KeyInUse"
import ListItemOptionReturn        from "../Keys/List/ListItemOptionReturn"
import BadgeKeyProgrammingState    from "../common/Badges/BadgeKeyProgrammingState"
import ListItemButtonKeyTimeLimits from "../Keys/ListItem/ButtonKeyTimeLimit"


interface props { item: ItemType }

const ListItem: React.FC<props> = ({ item }: props) => {
    const keyLockingSystemPermissionsCount:number = item.counts?.lockingSystemPermissions || 0;
    const itemBaseUrl: string = '/keys-in-use'

    const {hasFeature: hasLockingSystemFeature} = useLockingSystems()
    const { t }   = useTranslation()
    const history = useHistory()
    const minButtonWidth: string = '50px'

    const goToKeyLockingSystemPermissions = (ev: any, itemId: number) => {
        ev.preventDefault()
        ev.stopPropagation()

        history.push(itemBaseUrl + '/' + itemId + '/locking-system-permissions')
    }

    return (
        <>
            <IonItem button detail routerLink={itemBaseUrl + '/' + item.id + '/view'} slot="start">
                <IconKeyInUse icon={item?.keyType?.icon} slot="start" />
                <IonLabel>
                    <h2>
                        {item.description}
                        {item.label && <span style={{ 'fontWeight': 300 }}>&nbsp;- {item.label}</span>}
                        <span className="ion-hide-sm-down" style={{ 'fontWeight': '200', 'fontSize': '14px' }}>
                            &nbsp;- {item.keyType?.lockingSystemType?.brand?.name} - {item.keyType?.name}
                        </span>
                    </h2>
                    <h3 style={{ 'color': "#777" }}>
                        <span>
                            {t('common.belongs_to')} {item.person?.firstName + ' ' + item.person?.lastName}
                        </span>
                        {item.person?.companyName &&
                        <span style={{ 'paddingLeft': '0.5rem' }}>
                            ({item.person?.companyName})
                        </span>
                        }
                    </h3>
                </IonLabel>
                {item.keyProgrammingState &&
                    <BadgeKeyProgrammingState item={item.keyProgrammingState} />
                }
                <IonButtons slot="end">
                    {hasLockingSystemFeature('HAS_TIME_LIMITS') === true &&
                        <span style={{ 'minWidth': minButtonWidth }}>
                            <ListItemButtonKeyTimeLimits keyItem={item} />
                        </span>
                    }
                    <span style={{ 'minWidth': minButtonWidth }}>
                        <IonButton color={keyLockingSystemPermissionsCount ? "medium" : "light"} fill="clear"
                                   onClick={ (ev) => goToKeyLockingSystemPermissions(ev, item.id) }
                                   shape="round" size="large" slot="end" style={{ 'fontSize': '1rem' }}>
                        <IonIcon slot="start" ios={shieldCheckmarkOutline} md={shieldCheckmarkSharp} />
                        {keyLockingSystemPermissionsCount ? keyLockingSystemPermissionsCount : '-'}
                    </IonButton>
                    </span>
                </IonButtons>
            </IonItem>
            <IonItemOptions slot="end">
                {item.options?.isBlockable  && <ListItemOptionBlock  item={item} />}
                {item.options?.isReturnable && <ListItemOptionReturn item={item} />}
                {item.options?.isResetable  && <ListItemOptionReset  item={item} />}
                {item.options?.isDeletable  && <ListItemOptionDelete item={item} />}
            </IonItemOptions>
        </>
    )
}

export default ListItem